<div class="row">
  <div class="col">
    <h3>Empresas bloqueadas - Envio individual</h3>
  </div>

  <div class="col-auto">
    <button class="btn btn-primary" type="button" (click)="irParaTelaPesquisa()">
      Voltar
    </button>
    <button class="btn btn-primary" type="button" [disabled]="empresaForm.invalid" (click)="abrirModalConfirmar()">Enviar</button>
  </div>
</div>
<div class="row">
  <div class="col">
    <p>
      <i class="fa fa-warning"></i> Consulta individual por CNPJ - Informar
      apenas os 8 primeiros dígitos do CNPJ
    </p>
  </div>
</div>

<form [formGroup]="empresaForm">
  <div class="row">
    <div class="col-md-2 col-12">
      <label class="form-label" for="cnpj">CNPJ da Empresa:</label>
    </div>
    <div class="col-md-2 col-12 bn-form-group">
      <input
        type="text"
        id="cnpj"
        class="form-control"
        formControlName="cnpj"
        onkeypress='return event.charCode >= 48 && event.charCode <= 57'
        maxlength="8"
        />
    </div>
  </div>
</form>

<ng-template #mensagemTermoAceite>
  <div class="bn-form-group row">
    <div class="col">
      <label>Termos e condições:</label>
    </div>
  </div>
  <div class="row">
    <div class="bn-form-group col-12">
      <textarea class="form-control" rows="10" disabled [(ngModel)]="textoTermoAceite"></textarea>
    </div>
  </div>
  <div class="bn-form-group row">
    <div class="col">
      <div class="form-check">
        <input type="checkbox" class="form-check-input" id="checkCiencia" [(ngModel)]="checkCiencia">
        <label class="form-check-label" for="checkCiencia">Possuo os poderes necessários conferidos pelo Agente Financeiro para acessar informações sigilosas, estou ciente e desejo continuar.</label>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #botoesTermosAceite>
  <button class="btn btn-default" (click)="cancelarAceite()">Cancelar</button>
  <button class="btn btn-primary" [disabled]="!checkCiencia" (click)="confirmarAceite()">Confirmar</button>
</ng-template>
